// Selling screens (quick bill, a table's order) ask for finger-sized controls
// while they are open: the `pos:` variant in packages/ui/src/styles.css applies
// under <html data-pos> on a touch device. On <html> so dialogs, which render
// outside the screen, grow too.
import { useEffect } from 'react'

export function useTouchSizes() {
  useEffect(() => {
    const root = document.documentElement
    root.dataset.pos = ''
    return () => {
      delete root.dataset.pos
    }
  }, [])
}
